<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-login" class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <!--    그외 -->
    <div class="vx-col">
      <div class="w-full text-center mb-6 md:mb-14">
        <img :src="loginTopImage" alt="login" class="w-full max-w-xs md:max-w-md lg:max-w-lg mx-auto mobile-logo" />
      </div>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center grid grid-cols-1 md:grid-cols-12" style="max-width: 1150px">
            <!--              style="display: grid; grid-template-columns: 550px 620px; grid-template-rows: 400px;">-->
            <div class="vx-col hidden md:block md:col-span-7" style="height: 500px; width: 640px">
              <img :src="loginLeftImage" style="width: 100%; height: 100%; object-fit: cover" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col h-full w-full d-theme-dark-bg col-span-1 md:col-span-5 mobile-login-container">
              <div class="p-4 md:p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-3 text-xl md:text-2xl">{{ $t("로그인") }}</h4>
                  <p class="text-sm md:text-base">{{ $t("아이디와 비밀번호를 입력해주세요.") }}</p>
                </div>

                <div class="pt-1">
                  <ml-input name="email" icon-no-border icon="icon icon-user" icon-pack="feather" label-placeholder="아이디 입력" v-model="emailInput" :danger="emailRules" class="w-full" />

                  <ml-input type="password" name="password" icon-no-border icon="icon icon-lock" icon-pack="feather" label-placeholder="비밀번호 입력" v-model="passwordInput" class="w-full mt-4 md:mt-6" @keyup.enter="login" />

                  <div class="flex flex-wrap justify-between my-4 md:my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3 text-sm">{{ $t("아이디 기억하기") }}</vs-checkbox>
                    <!--                    <router-link to="/forgot-password">{{ $t('비밀번호를 잊으셨나요?') }}</router-link>-->
                  </div>
                  <!--
                  # 자동방지문자 : google
                  -->

                  <vue-recaptcha v-if="recaptcha" class="mb-6 md:mb-8" ref="recaptcha" @expired="onExpired" @render="cargarCaptchar = true" @error="recaptchar = false" @verify="onVerify" sitekey="6LdUVN0aAAAAAH3ks4Ji-iuhmZ00-Af6W9xhxZGU" />

                  <vs-button v-if="isLoginInProgress" class="w-full md:float-right md:w-auto" color="secondary" disabled>{{ $t("잠시만 기다려주세요") }}</vs-button>
                  <div v-else class="flex flex-col md:flex-row md:justify-between gap-3 md:gap-0">
<!--                    <vs-button color="secondary" type="border" to="/register" class="w-full md:w-auto text-sm md:text-base">{{ $t("회원가입") }}</vs-button>-->
                    <vs-button color="secondary" @click="login" class="w-full md:w-auto text-sm md:text-base">{{ $t("로그인") }}</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import config from "/public/config";
import VueCookie from "vue-cookie";
import constant from "@/constant/constant";
import VueRecaptcha from "vue-recaptcha";

export default {
  components: {
    VueRecaptcha,
  },
  watch: {
    checkbox_remember_me(checkbox_remember_me) {
      this.checkbox_remember_me = checkbox_remember_me;
      VueCookie.set("login_remember_me", checkbox_remember_me, 30);

      if (!this.checkbox_remember_me) {
        VueCookie.set("login_remember_email", "");
      }
    },
  },
  data() {
    return {
      loginLeftImage: require("@/assets/images/pages/login2.svg"),
      loginTopImage: require("@/assets/images/pages/shm_logo_Login.svg"),
      hostname: config.HOST_NAME,
      emailInput: "",
      passwordInput: "",
      checkbox_remember_me: false,
      recaptcha: false,
      recaptchaValue: "",
      isLoginInProgress: false, // 로그인 진행중인지 여부
    };
  },
  computed: {
    emailRules() {
      return this.checkEmailRule(this.emailInput);
    },
  },
  created() {
    this.loadLoginLeftImage().then();
    this.loadLoginTopImage().then();

    this.checkbox_remember_me = VueCookie.get("login_remember_me") === "true";
    if (this.checkbox_remember_me) {
      this.emailInput = VueCookie.get("login_remember_email") ? VueCookie.get("login_remember_email") : "";
    }
  },
  methods: {
    onVerify(r) {
      this.recaptchaValue = r;
      this.recaptcha = true;
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },

    /**
     * 로그인 화면에서 왼편에 표시되는 이미지를 불러온다
     */
    async loadLoginLeftImage() {
      // 로컬 스토리지에 `${host_name}_login_left_image` 키로 저장된 이미지가 있는지 확인한다.
      // 있으면 그 이미지를 사용하고, 없으면 서버에서 이미지를 가져와서 로컬 스토리지에 저장한다.
      if (localStorage.getItem(`${this.hostname}_login_left_image`)) {
        this.loginLeftImage = localStorage.getItem(`${this.hostname}_login_left_image`);
      }

      const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
        key: "login_left_image",
      });

      if (config && config.path) {
        // 로컬 스토리지에 저장한다
        localStorage.setItem(`${this.hostname}_login_left_image`, config.path);

        this.loginLeftImage = config.path;
      }
    },

    /**
     * 로그인 화면에서 상단에 표시되는 이미지를 불러온다
     */
    async loadLoginTopImage() {
      // 로컬 스토리지에 `${host_name}_login_top_image` 키로 저장된 이미지가 있는지 확인한다.
      // 있으면 그 이미지를 사용하고, 없으면 서버에서 이미지를 가져와서 로컬 스토리지에 저장한다.
      if (localStorage.getItem(`${this.hostname}_login_top_image`)) {
        this.loginTopImage = localStorage.getItem(`${this.hostname}_login_top_image`);
      }

      const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
        key: "login_top_image",
      });

      if (config && config.path) {
        // 로컬 스토리지에 저장한다
        localStorage.setItem(`${this.hostname}_login_top_image`, config.path);

        this.loginTopImage = config.path;
      }
    },

    handleChangeRememberMe(/*data*/) {},
    checkEmailRule(v) {
      if (v === "") {
        return true;
      }

      const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
      return !regExp.test(v);
    },

    async login() {
      if (this.isLoginInProgress) return;

      const email = this.emailInput;
      const pw = this.passwordInput;
      const rcv = this.recaptchaValue;

      if (!email) {
        alert("아이디를 입력해주세요");
        return;
      }
      if (email.length < 3) {
        alert("아이디는 3글자 이상이어야 합니다.");
        return;
      }

      if (!pw) {
        alert("비밀번호를 입력해주세요");
        return;
      }

      // 비밀번호가 8자 이상, 소문자, 대문자, 숫자가 포함되어있는지 검증
      // if (!/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,255}$/.test(pw)) {
      //   alert("비밀번호는 8자 이상, 소문자, 대문자, 숫자가 포함되어야 합니다.");
      //   return;
      // }

      this.isLoginInProgress = true;

      this.$store
        .dispatch("LOGIN", { email, pw, rcv })
        .then(async () => {
          if (VueCookie.get("login_remember_me") === "true") {
            VueCookie.set("login_remember_email", this.emailInput, 30);
          }

          localStorage.setItem("login_username", email);

          // localStorage에 보관되어 있는 키들을 가져온다
          const keys = Object.keys(localStorage);
          // _boardIds 로 끝나는 키들을 찾아서 삭제한다.
          keys.forEach((key) => {
            if (key.endsWith("_boardIds")) {
              localStorage.removeItem(key);
            }
          });
          localStorage.removeItem("/api/auth/me");
          localStorage.removeItem("/api/v1/member/all");
          localStorage.removeItem("sub_company");

          // 사용자의 프로젝트 참여 현황을 조회하기 위해서, 사용자 정보를 조회한다
          await this.$store.dispatch("member/LOAD_MEMBER_DETAIL", { project_id: -1 /* 강제로 서버에서 불러오도록 한다 */ });
          const memberInfo = this.$store.state.member.memberInfo;

          const toFullPath = VueCookie.get("LOGIN_TO_FULLPATH");
          if (toFullPath) {
            this.$router.replace(toFullPath).then((/*value*/) => {
              VueCookie.delete("LOGIN_TO_FULLPATH"); // 로그인 후 이동할 페이지 삭제
              this.$router.go(0);
            });
          } else {
            // 참여 프로젝트의 개수가 1개일 경우, 해당 프로젝트 페이지로 바로 이동시킨다
            const projects = memberInfo.projects || [];
            if (memberInfo.projects.length === 1) {
              this.$router.replace(`/project/${projects[0].id}/home`).then((/*value*/) => {
                this.$router.go(0);
              });
            } else {
              this.$router.replace("/home").then((/*value*/) => {
                this.$router.go(0);
              });
            }
          }
        })
        .catch((err) => {
          if (this.recaptcha) {
            this.$refs.recaptcha.reset();
          }

          switch (constant.getErrorCode(err)) {
            case constant.ERROR_LOGIN_ID_NULL:
              alert("아이디를 입력해주세요");
              break;
            case constant.ERROR_LOGIN_PASSWORD_NULL:
              alert("비밀번호를 입력해주세요");
              break;
            case constant.ERROR_LOGIN_INVALID_CREDENTIALS:
              alert("아이디 또는 패스워드가 틀립니다");
              break;
            case constant.ERROR_LOGIN_INVALID_RECAPTCHA:
              this.recaptcha = true;
              break;
            case -1:
              switch (err.response.data) {
                case "The login must be between 2 and 255 characters.":
                  alert("아이디는 2자 이상 255자 이하로 입력해주세요.");
                  break;
                case "The password must be between 4 and 255 characters.":
                  alert("비밀번호는 4자 이상 255자 이하로 입력해주세요.");
                  break;
                default:
                  alert(err.response.data);
                  break;
              }
              break;
          }
          this.isLoginInProgress = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}

.input-font::v-deep {
  span {
    font-size: 16px !important;
    height: 100%;
  }
  input {
    font-size: 16px !important;
  }
}

// 모바일 최적화 스타일
.mobile-logo {
  max-height: 80px;

  @media (min-width: 768px) {
    max-height: 120px;
  }
}

.mobile-login-container {
  padding: 20px 0;

  @media (min-width: 768px) {
    padding: 40px 0;
  }
}

@media print, screen and (max-width: theme("screens.xl")) {
  .vx-col {
    width: 95%;
  }

  .lt-postion-logo {
    display: none;
  }
}

// 모바일에서 추가 최적화
@media (max-width: 767px) {
  #page-login {
    padding: 10px;

    .vx-card {
      margin: 0 !important;
      box-shadow: none !important;
    }

    .login-tabs-container {
      padding: 16px !important;

      .vx-card__title {
        margin-bottom: 16px !important;

        h4 {
          font-size: 20px !important;
          margin-bottom: 8px !important;
        }

        p {
          font-size: 14px !important;
        }
      }

      .vs-button {
        height: 44px !important;
        font-size: 14px !important;
        font-weight: 500 !important;
      }
    }

    // 입력 필드 최적화
    .vs-input-parent {
      margin-bottom: 12px !important;
    }

    // 체크박스 텍스트 크기
    .vs-checkbox {
      font-size: 14px !important;
    }
  }
}
</style>
